var BaseComponent = /** @class */ (function () {
    function BaseComponent(tag) {
        if (tag === void 0) { tag = 'div'; }
        this.element = document.createElement(tag);
    }
    return BaseComponent;
}());
var elementBaseComponent = function (tag, classes, children) {
    if (tag === void 0) { tag = 'div'; }
    var element = new BaseComponent(tag);
    var classesElement = classes.join(' ');
    element.element.className = classesElement;
    children.forEach(function (child) {
        element.element.append(child);
    });
    return element;
};
export { BaseComponent, elementBaseComponent };
